import { createFileRoute, notFound } from "@tanstack/react-router";

import { MediaView } from "@/components/pages/MediaView";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/media")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/media",
          ...meta[params.locale].media,
        })
      : {},
  component: MediaRoute,
});

function MediaRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <MediaView locale={locale} />;
}
